import React from 'react';
import { Button } from '@amzn/awsui-components-console';

import ShowSnowStatus from 'src/components/findEntity/ShowSNOWStatus';
import { UserIcon } from 'src/components/commonComponents/UserIcon';

export const getPhoneToolImageURL = (user) => {
	return 'https://badgephotos.corp.amazon.com/?uid=' + user;
};

export const getPhoneToolProfileURL = (user) => {
	return 'https://phonetool.amazon.com/users/' + user;
};

export const DASHBOARD_COLUMNS = [
	{
		id: 'node_id',
		header: 'Entity Name',
		cell: (item) => (
			<Button
				variant="inline-link"
				href={`#/findEntity?name=${item.node_id}&workflowType=${item.workflow_id}&entityType=${item.entity_type}`}
				target="_blank"
			>
				{item.node_id}
			</Button>
		),
		minWidth: 90,
	},
	{
		id: 'entity_type',
		header: 'Entity Type',
		cell: (item) => item.entity_type,
		minWidth: 90,
	},
	{
		id: 'workflow_type',
		header: 'Workflow Type',
		cell: (item) => item.workflow_type || item.workflow_id,
		minWidth: 150,
	},
	{
		id: 'workflow_status',
		header: 'Status',
		cell: (item) => (
			<ShowSnowStatus status={item.workflow_status}>
				{item.workflow_status}
			</ShowSnowStatus>
		),
		minWidth: 150,
	},
	{
		id: 'created_by',
		header: 'Created By',
		cell: (item) => <UserIcon user={item.submitted_by || item.created_by} />,
		minWidth: 150,
	},
	{
		id: 'creation_time',
		header: 'Created On',
		cell: (item) => item.creation_time,
		minWidth: 180,
	},
	{
		id: 'region',
		header: 'Region',
		cell: (item) => item.region,
		minWidth: 90,
	},
	{
		id: 'country',
		header: 'Country',
		cell: (item) => item.country,
		minWidth: 90,
	},
	{
		id: 'cycle_id',
		header: 'Cycle ID',
		cell: (item) => item.cycle_id,
		minWidth: 100,
	},
];

export const paginationLabels = {
	nextPageLabel: 'Next page',
	pageLabel: (pageNumber) => `Go to page ${pageNumber}`,
	previousPageLabel: 'Previous page',
};

export const TABLE_MESSAGE = {
	NODES_NOT_FOUND: 'No Entities found',
	WORKFLOW_TYPE_NOT_SELECTED:
		'Select a workflow type or choose filters to get started.',
	NO_MATCH_FOUND: 'No results found for your query',
};

export const PAGE_HEADER_DESCRIPTION =
	'Displays list of nodes associated with a workflow or node/ group id';

export const PAGE_HEADER = 'Entity Search';

export const PROPERTY_FILTER_PLACEHOLDER_TEXT = {
	WORKFLOW_TYPE_UNSELECTED:
		'Select workflow type to view search filters or Provide GroupId here to search',
	FILTER: 'Filter Search',
	NO_FILTER: 'No filter available',
};

export const SELECT_WORKFLOW_MESSAGES = {
	LOADING: 'Loading workflow types...',
	SELECT: 'Select workflow type',
	NO_OPTIONS: 'No workflow types available',
	ERROR: 'Failed to load workflow types',
	LOADING_LABEL: 'Loading workflow types',
	SELECT_LABEL: 'Select workflow type',
	INLINE_LABEL: 'Select Workflow Type',
} as const;

export const VISIBLE_COLUMNS = [
	'node_id',
	'entity_type',
	'workflow_type',
	'region',
	'created_by',
	'creation_time',
	'workflow_status',
];

export const PAGE_SELECTOR_OPTIONS = [
	{ value: 10, label: '10 entities' },
	{ value: 25, label: '25 entities' },
	{ value: 50, label: '50 entities' },
	{ value: 100, label: '100 entities' },
];

export const COLLECTION_PREFERENCES = {
	title: 'Preferences',
	confirmLabel: 'Confirm',
	cancelLabel: 'Cancel',
	pageSizePreference: {
		title: 'Select page size',
		options: PAGE_SELECTOR_OPTIONS,
	},
	wrapLinesPreference: {
		label: 'Wrap lines',
		description: 'Wrap text content within table cells',
	},
	stripedRowsPreference: {
		label: 'Striped rows',
		description: 'Add alternating row colors for easier reading',
	},
	contentDisplayPreference: {
		options: [
			{ id: 'node_id', label: 'Entity Name', alwaysVisible: true },
			{ id: 'entity_type', label: 'Entity Type' },
			{ id: 'workflow_status', label: 'Status' },
			{ id: 'created_by', label: 'Created By' },
			{ id: 'creation_time', label: 'Created On' },
			{ id: 'region', label: 'Region' },
			{ id: 'country', label: 'Country' },
			{ id: 'cycle_id', label: 'Cycle ID' },
		],
	},
};

export const WORKFLOW_ACTION_URLS = {
	'ANCHOR_POINT_WORKFLOW': '#/launchAnchorPointWorkflow',
};
